// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"116":"7efb9457","243":"c557daa8","635":"d1472d4f","664":"e7e5229e","797":"c021415e","837":"71c39e0b"}[chunkId] + ".chunk.js";
};